module.exports = __webpack_public_path__ + "static/media/Offshore-wind.77709a20.svg";